import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import {
  Dog,
  Heart,
  AlertCircle,
  CheckCircle2,
  Info,
  Activity,
  Users,
  Brain,
} from 'lucide-react';
import { motion } from 'framer-motion';
import { useAnalysis } from '../AnalysisContext';
import DescripcionGeneralCard from './guiaRaza/DescripcionGeneralCard';
import CaracteristicasFisicasCard from './guiaRaza/CaracteristicasFisicasCard';
import TemperamentoCard from './guiaRaza/TemperamentoCard';
import EspacioYEntornoCard from './guiaRaza/EspacioYEntornoCard';
import PerfilDuenoCard from './guiaRaza/PerfilDuenoCard';
import CostoYMantenimientoCard from './guiaRaza/CostoYMantenimientoCard';
import MitosYRealidadesCard from './guiaRaza/MitosYRealidadesCard';

const BreedCharacteristicsTab = () => {
  const { analysisData, breedGuide } = useAnalysis();

  if (!analysisData) return null;


  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-6xl mx-auto px-4 sm:px-6 py-4 sm:py-6 space-y-6 sm:space-y-8"
    >
      <DescripcionGeneralCard descripcionGeneral={breedGuide?.cuidadosSalud?.guiaDeRaza?.descripcionGeneral} razaPrincipal={analysisData?.metaAnalisis?.razaPrincipal}/>
      <CaracteristicasFisicasCard caracteristicasFisicas={breedGuide?.cuidadosSalud?.guiaDeRaza?.caracteristicasFisicas} />
      <TemperamentoCard temperamento={breedGuide?.cuidadosSalud?.guiaDeRaza?.temperamento} />
      <EspacioYEntornoCard espacioYEntorno={breedGuide?.cuidadosSalud?.guiaDeRaza?.espacioYEntorno} />
      <PerfilDuenoCard perfilDueno={breedGuide?.cuidadosSalud?.guiaDeRaza?.perfilDueno} />
      <CostoYMantenimientoCard costoYMantenimiento={breedGuide?.cuidadosSalud?.guiaDeRaza?.costoYMantenimiento} />
      <MitosYRealidadesCard mitosYRealidades={breedGuide?.cuidadosSalud?.guiaDeRaza?.mitosYRealidades} />

      <Alert className="bg-blue-50 border-blue-200">
        <Info className="h-4 w-4 text-blue-500" />
        <AlertDescription className="text-sm sm:text-sm text-blue-700">
          Esta información está basada en datos estadísticos y estudios de la raza.
          Cada perro es único y puede presentar variaciones.
        </AlertDescription>
      </Alert>
    </motion.div>
  );
};

export default BreedCharacteristicsTab;